(ns frontend.ux-overhaul.listing.zap-vault.view
  (:require [common.localization :as loc]
            [common.opensearch.row :as os-row]
            [frontend.ux-overhaul.listing.generic.event :as generic-event]
            [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
            [frontend.ux-overhaul.listing.generic.view :as listing]
            [frontend.ux-overhaul.listing.zap-vault.event :as zap-vault-event]
            [frontend.ux-overhaul.page-components.navigation.events :as nav-events]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(def listing-id "zap-vault-listing")

(defn- open-zap-vault!
  [value]
  (when-let [entity-id (os-row/entity-id value)]
    (rf/dispatch [::nav-events/navigate-to {:path [:entity.type/zap-vault :id entity-id :tab :documents]}])))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id           listing-id
         :entity-type          :entity.type/zap-vault
         :pipeline-id          nil
         :filters              {:enabled? true
                                :view-id :zap-vault
                                :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes #{:grid :kanban :gallery :list}
         :toolbar-actions      [{:id       :create-zap-vault
                                 :label    (loc/tr :create-new-vault)
                                 :visible? true
                                 :enabled? true
                                 :event    [::zap-vault-event/create-zap-vault]}]}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      [listing/view
       {:listing-id               listing-id
        :title                    (loc/tr :zap-vaults)
        :show-view-mode-selector? true
        :query-placeholder        (loc/tr :listing.zap-vault/search-placeholder)
        :on-create-first-item     #(rf/dispatch [::zap-vault-event/create-zap-vault])
        :on-row-clicked           open-zap-vault!
        :on-card-clicked          open-zap-vault!}])}))
